import { classnames } from 'helpers/utils';
import styles from './note-input.module.scss';

type NoteProps = {
  note: string;
  setNote: (note: string) => void;
  maxChars: number;
  placeholder: string;
};
const NoteInput: React.FC<NoteProps> = ({
  note,
  setNote,
  maxChars,
  placeholder,
}) => (
  <label htmlFor="note" className={styles.notesContainer}>
    <div className={styles.titleContent}>
      <span className="text__body__semi__bold__medium__gray800">Note</span>
      <span className="text__body__regular__medium__gray500">Optional</span>
    </div>
    <textarea
      id="note"
      value={note}
      onChange={(e) => setNote(e.target.value)}
      maxLength={maxChars}
      placeholder={placeholder}
      className={classnames(
        styles.textArea,
        'text__body__regular__medium__gray500',
      )}
    />
    <span className="text__body__regular__tiny__gray700">
      {note.length}/{maxChars}
    </span>
  </label>
);

export { NoteInput };
